<template>
  <svg width="20"
       height="19"
       viewBox="0 0 20 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M6.47559 3.13281V3.99414H13.5244V3.13281C13.5244 2.7373 13.252 2.48242 12.8125 2.48242H7.17871C6.74805 2.48242 6.47559 2.7373 6.47559 3.13281ZM9.99121 9.31152C6.53711 9.31152 3.24121 8.78418 0.0419922 7.44824V6.80664C0.0419922 4.95215 1.00879 3.99414 2.88086 3.99414H4.64746V3.05371C4.64746 1.64746 5.55273 0.8125 7.06445 0.8125H12.9268C14.4385 0.8125 15.3438 1.64746 15.3438 3.05371V3.99414H17.1104C18.9912 3.99414 19.9492 4.95215 19.9492 6.80664V7.44824C16.75 8.78418 13.4541 9.31152 9.99121 9.31152ZM2.88086 18.1973C1.00879 18.1973 0.0419922 17.248 0.0419922 15.3848V9.11816C2.71387 10.0938 5.12207 10.5508 7.55664 10.7354V11.4297C7.55664 12.0977 7.94336 12.4668 8.62012 12.4668H11.3623C12.0479 12.4668 12.4346 12.0977 12.4346 11.4297V10.7354C14.8691 10.5508 17.2773 10.0938 19.9492 9.11816V15.3848C19.9492 17.248 18.9912 18.1973 17.1104 18.1973H2.88086Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'PrimaryIcon',
  props: {
    width: {
      type: Number,
      default: 13
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
